import Base from 'src/storage/base';

class AllStatsModel extends Base {
  defaultState = () => ({ tab: 'doctors' });

  apiConfig = {};
  router = {};

  _events = {};
}

const model = new AllStatsModel();

export default model;
